/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Loading_CatalogueInputs */

const en_us2_history_transfer_loading_catalogue = /** @type {(inputs: History_Transfer_Loading_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading the exercise catalogue…`)
};

const pt_br2_history_transfer_loading_catalogue = /** @type {(inputs: History_Transfer_Loading_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando o catálogo de exercícios…`)
};

const es_419_history_transfer_loading_catalogue = /** @type {(inputs: History_Transfer_Loading_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando el catálogo de ejercicios…`)
};

const pt_pt2_history_transfer_loading_catalogue = /** @type {(inputs: History_Transfer_Loading_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar o catálogo de exercícios…`)
};

const fr_fr2_history_transfer_loading_catalogue = /** @type {(inputs: History_Transfer_Loading_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement du catalogue d'exercices…`)
};

const de_de2_history_transfer_loading_catalogue = /** @type {(inputs: History_Transfer_Loading_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungskatalog wird geladen…`)
};

const it_it2_history_transfer_loading_catalogue = /** @type {(inputs: History_Transfer_Loading_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento del catalogo esercizi…`)
};

/**
* | output |
* | --- |
* | "Loading the exercise catalogue…" |
*
* @param {History_Transfer_Loading_CatalogueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_loading_catalogue = /** @type {((inputs?: History_Transfer_Loading_CatalogueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Loading_CatalogueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_loading_catalogue(inputs)
	if (locale === "es-419") return es_419_history_transfer_loading_catalogue(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_loading_catalogue(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_loading_catalogue(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_loading_catalogue(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_loading_catalogue(inputs)
	return en_us2_history_transfer_loading_catalogue(inputs)
});
export { history_transfer_loading_catalogue as "history-transfer.loading_catalogue" }